export class TableName {
  static SOCIAL_MEDIA = "socialMedia";
  static CONTACT_US = "contactUs";
  static NEWS = "news";
  static COLLABORATION = "collaboration";
  static USERS = "users";
  static BOUSERS = "boUsers";
  static NORMALRESERVATIONS = "normalReservations";
  static EVENTRESERVATIONS = "eventReservations";
  static RESERVATIONSETTINGS = "reservationSettings";
  static MODULES = "modules";
  static MAINTENANCE = "maintenance";
  static GENERAL = "general";
  static FEATURES = "features";
  static NORMALRESERVATIONSLOTSETTINGS = "normalReservationSlotSettings";
  static EVENTRESERVATIONSLOTSETTINGS = "eventReservationSlotSettings";

  static TableNameList = [
    {
      key: TableName.SOCIAL_MEDIA,
      value: "Social Media",
    },
    {
      key: TableName.CONTACT_US,
      value: "Contact Us",
    },
    {
      key: TableName.NEWS,
      value: "News",
    },
    {
      key: TableName.COLLABORATION,
      value: "Collaboration",
    },
    {
      key: TableName.USERS,
      value: "Users",
    },
    {
      key: TableName.BOUSERS,
      value: "BO Users",
    },
    {
      key: TableName.NORMALRESERVATIONS,
      value: "Normal Reservations",
    },
    {
      key: TableName.EVENTRESERVATIONS,
      value: "Event Reservations",
    },
    {
      key: TableName.RESERVATIONSETTINGS,
      value: "Reservation Settings",
    },
    {
      key: TableName.MODULES,
      value: "Modules",
    },
    {
      key: TableName.MAINTENANCE,
      value: "Maintenance",
    },
    {
      key: TableName.GENERAL,
      value: "General",
    },
    {
      key: TableName.FEATURES,
      value: "Features",
    },
    {
      key: TableName.NORMALRESERVATIONSLOTSETTINGS,
      value: "Normal Reservation Slot Settings",
    },
    {
      key: TableName.EVENTRESERVATIONSLOTSETTINGS,
      value: "Event Reservation Slot Settings",
    },
  ];

  static getTableNameValue = (key) => {
    return (
      TableName.TableNameList.find((item) => item.key === key)?.value ??
      "Table Name Not Found"
    );
  };
}
